import { useNavigate } from "react-router-dom";
import { AuthenticatedTemplate } from "@azure/msal-react";
import { Button } from "@mui/material";
import { useEffect } from "react";
import AdminTabPanel from "../admin/AdminTabPanel";
import { useAdminStatus } from "../../hooks/useAdminStatus";
import LogoutButton from "../auth/LogoutButton";
// import { STEP_DATA } from "../steps/initializeSteps";
// import useFetching from "../../utils/Fetching";

const AdminPage = () => {
  const navigate = useNavigate();
  const isAdmin = useAdminStatus();
  //const { saveStepData } = useFetching();

  const navigateOnboarding = () => {
    navigate("/onboarding");
  };

  useEffect(() => {
    if (isAdmin !== null && !isAdmin) {
      navigateOnboarding();
    }
  }, [isAdmin]);

  // const initialize = async () => {
  //   STEP_DATA.forEach(async (step) => {
  //     await saveStepData(step);
  //   });
  // };

  return (
    <AuthenticatedTemplate>
      <div className="admin-page">
        <div className="button-wrapper">
          <Button variant="contained" onClick={navigateOnboarding}>
            Onboarding
          </Button>{" "}
          {/* <Button onClick={initialize}>Initialize</Button> */}
          <LogoutButton />
        </div>
        <div className="tables-container">
          {isAdmin && <AdminTabPanel />}
          {isAdmin === null && <div className="loading-spinner"></div>}
        </div>
      </div>
    </AuthenticatedTemplate>
  );
};

export default AdminPage;
